import React, { FC } from "react";
import { useTranslation } from "i18n";
import cx from "classnames";
import { TextArea, isMediumDeviceWidth } from "component-library";
import { FEATURE_FLAGS, useLaunchDarklyFlags } from "shared-services";
import { IMakeupViewModel } from "shared/modules/BasicInfo/models/views/MakeupViewModel";
import { ControlSection } from "shared/modules/Common";

interface IMakeupProps {
  model: IMakeupViewModel;
  handleChanges: (model: IMakeupViewModel) => void;
}

const TEXTAREA_MAX_LENGTH = 250;

export const MAKEUP_TEXTAREA_TEST_ID = "makeup-textarea";

const Makeup: FC<React.PropsWithChildren<IMakeupProps>> = ({
  handleChanges,
  model,
}: IMakeupProps) => {
  const { t } = useTranslation();
  const isMakeupDetailsFlagOn = useLaunchDarklyFlags(
    FEATURE_FLAGS.ProfileMakeupDetails
  );

  const handleChangeValue = (value: string) => {
    const updatedModel = { ...model };

    updatedModel.makeUp = value;

    handleChanges(updatedModel);
  };

  if (!isMakeupDetailsFlagOn) {
    return null;
  }

  return (
    <ControlSection
      name={t("performer:profile.edit.makeUp.sectionTitle")}
      description={t("performer:profile.edit.makeUp.sectionDescription")}
    >
      <div
        className={cx("c-additional-info-form pt-5", {
          "c-additional-info-form__control-grid-2": !isMediumDeviceWidth(),
        })}
      >
        <TextArea
          maxLength={TEXTAREA_MAX_LENGTH}
          showsCharacterCount
          placeholder={t("performer:profile.edit.makeUp.textArea.placeholder")}
          label={t("performer:profile.edit.makeUp.textArea.label")}
          name="makeUp"
          value={model.makeUp}
          valueChanged={handleChangeValue}
          test-id={MAKEUP_TEXTAREA_TEST_ID}
        />
      </div>
    </ControlSection>
  );
};

export default Makeup;
